
export const promptsArray = [
    "Who are you professionally?",
    "How do you bridge the gap between Design and Engineering?",
    "How do you explain technical concepts to business leaders?",
    "How would your team describe your leadership style?",
    "Give me a tour of your career path.",
    "-",
    "Walk me through a complex system you built.",
    "How do you decide what NOT to build?",
    "Biggest strengths -  and the tradeoffs that come with them?",
    "How do you handle technical debt?",
    "Honestly... Tabs or Spaces?",

    // "-",
    // "What kind of teams do you do your best work with?",
    // "What technologies or ideas are you genuinely excited about right now?",
    // "Why did you build this site?"



];

export const promptsArray1 = [
    "Who are you professionally?",
    "How do you bridge the gap between Design and Engineering?",
    "How do you explain technical concepts to business leaders?",
    "Walk me through a complex system you built.",
    "What is your leadership style?",
    "Tabs or Spaces?",
    "What are your biggest strengths and weaknesses?",
    "How do you decide what NOT to build?",

    "Tell me about a major architectural mistake you made.",
    "How do you balance speed vs. code quality?",
    "How do you handle technical debt?",
    "What is your approach to hiring and team building?",
    "How do you handle disagreement with founders?",
    "How do you manage underperforming engineers?",
    "What does your ideal engineering culture look like?",
    "How do you mentor junior developers?",
    "What technologies are you excited about right now?",
    "Give me a tour of your career path.",
    "How do you approach large-scale migrations?",
    "How do you bridge the gap between Design and Engineering?",
    "What is your philosophy on Testing and QA?",
];


export const promptsArray2 = [
    "Who are you professionally?",
    "How do you ensure product and design intent survives implementation?",
    "How do you explain complex technical tradeoffs to business leaders?",
    "Walk me through a complex system you built end-to-end.",
    "How would your team describe your leadership style?",

    // Phase 2 — Product, Strategy & Judgement
    "How do you turn vague ideas into real, shippable systems?",
    "How do you decide what not to build?",
    "How do you make decisions when the right answer isn’t clear?",
    "What are your biggest strengths — and the tradeoffs that come with them?",
    "How do you balance speed with long-term system health?",

    // Phase 3 — People & Culture (Senior Lens)
    "What does your ideal engineering culture look like in practice?",
    "Tell me about a difficult people decision you had to make.",
    "How do you handle disagreement with founders or executives?",
    "How do you mentor engineers into senior roles?",
    "What kind of teams do you do your best work with?",

    // Phase 4 — Depth, Taste & Personality
    "Tell me about a major architectural mistake you made — and what changed.",
    "How do you prevent systems and processes from slowing teams down?",
    "What technologies or ideas are you genuinely excited about right now?",
    "Give me a tour of your career path and how it evolved.",
    "Why did you build this site as a digital twin?"
];